export const IMPERSONATE_KEY = 'isImpersonated';
export const TWO_FACTOR_BLOCKED_UNTIL_KEY = 'sonarprint-twoFactorBlockedUntil';
